export const BankFormSchema = () => {
    return {
        name: {
            type: "text",
            label: "Bank Name",
            columns: {md: 6},
            validation: (value) => {
                if (value.trim() === "") return "Bank name is required";
                return null;
            },
        },
        accountHolderName: {
            type: "text",
            label: "Account Holder Name",
            columns: {md: 6},
            validation: (value) => {
                if (value.trim() === "") return "Account holder name is required";
                return null;
            },
        },
        accountNumber: {
            type: "text",
            label: "Account Number",
            columns: {md: 6},
            validation: (value) => {
                const strValue = value !== undefined && value !== null ? value.toString().trim() : "";

                if (strValue === "") {
                    return "Account number is required";
                }

                return null;
            },
        },
        ifscCode: {
            type: "text",
            label: "IFSC Code",
            columns: {md: 6},
            validation: (value) => {
                if (value.trim() === "") return "IFSC code is required";
                return null;
            },
        },
        branchAddress: {
            type: "text",
            label: "Branch Address",
            columns: {md: 6},
            validation: (value) => {
                if (value.trim() === "") return "Branch address is required";
                return null;
            },
        },
        upiId: {
            type: "text",
            label: "UPI ID",
            columns: {md: 6},
            validation: (value) => {
                return null;
            },
        },
    };
};